import { C43MediaGalleryItemProps } from './C43MediaGalleryItem.types';
import { MediaItem } from '@ahc-digital/component-library';
import { ReactNode } from 'react';
import { getCheckbox } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

type MediaItemWithSupport = MediaItem & {
  audioSrcField: ReactNode;
};

export function GetMediaGalleryItemModel(
  props?: Pick<C43MediaGalleryItemProps, 'fields'>,
  shouldLazyLoad?: string | undefined
): MediaItemWithSupport {
  const { renderText, renderRichText, renderImage, renderFile } = useConditionalRendering();
  const { fields } = props || {};
  const slide: MediaItemWithSupport = {
    image: renderImage(fields?.Image),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    videoId: fields?.VideoID?.value,
    videoIdField: renderText(fields?.VideoID),
    audioSrc: fields?.AudioSource?.value?.src,
    audioSrcField: renderFile(fields?.AudioSource),
    shouldLazyLoad: getCheckbox(shouldLazyLoad),
  };
  return slide;
}
